var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4023 19.0498V6.20215H6.34766V19.0498H16.4023ZM16.4023 4.39746C16.8893 4.39746 17.319 4.58366 17.6914 4.95605C18.0638 5.2998 18.25 5.71517 18.25 6.20215V19.0498C18.25 19.5368 18.0638 19.9665 17.6914 20.3389C17.319 20.7113 16.8893 20.8975 16.4023 20.8975H6.34766C5.86068 20.8975 5.43099 20.7113 5.05859 20.3389C4.6862 19.9665 4.5 19.5368 4.5 19.0498V6.20215C4.5 5.71517 4.6862 5.2998 5.05859 4.95605C5.43099 4.58366 5.86068 4.39746 6.34766 4.39746H16.4023ZM13.6523 0.702148V2.5498H2.65234V15.3975H0.847656V2.5498C0.847656 2.06283 1.01953 1.63314 1.36328 1.26074C1.73568 0.888346 2.16536 0.702148 2.65234 0.702148H13.6523Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopy);
export default __webpack_public_path__ + "static/media/File_copy.e7085f5d0d6884f5f32151d65e6f2dbd.svg";
export { ForwardRef as ReactComponent };